export default "__VITE_ASSET__Cp$O82nz__"